import React from "react";

const Banner = () => {
  return (
    <div
      className="relative w-full overflow-hidden bg-[#355931]"
      style={{
        height: "calc(100dvh - 101px)", // 100px navbar (h-25) + 1px border-b
        minHeight: "480px",
      }}
    >
      {/* Video */}
      <video
        autoPlay
        loop
        playsInline
        preload="auto"
        muted
        src="/Banner_Video.mp4"
        className="absolute inset-0 w-full h-full object-cover"
        aria-hidden="true"
        role="presentation"
      >
        <track kind="captions" srcLang="en" label="English" default />
      </video>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/20 z-[5]" />

      {/* Content — perfectly centered in remaining viewport */}
      <div className="absolute inset-0 z-10 flex items-center justify-start">
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div
            className="w-full
                       max-w-[88vw] sm:max-w-md md:max-w-xl lg:max-w-2xl
                       rounded-2xl
                       px-5 sm:px-8 md:px-10
                       py-6 sm:py-8 md:py-10
                       shadow-[0_10px_40px_rgba(0,0,0,0.3)]"
            style={{
              backgroundColor: "rgba(53,89,49,0.82)",
              backdropFilter: "blur(3px)",
            }}
          >
            <h1
              className="text-white font-medium leading-tight
                         text-xl sm:text-2xl md:text-3xl lg:text-4xl"
            >
              The CDMO Behind Fast-Growing Nutraceutical Brands
            </h1>

            <p
              className="text-white/90 leading-relaxed
                         mt-3 sm:mt-4 md:mt-5
                         text-sm sm:text-sm md:text-base
                         max-w-[95%] sm:max-w-xs md:max-w-md lg:max-w-lg"
            >
              Manufacturing superior-quality supplements in an FSSAI-approved
              A-grade facility with a focus on quality, compliance, and innovation.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;